module.exports = __webpack_public_path__ + "assets/img/meat_grubder_active.2fe83ceb.png";